// src/hooks/useScrollToId.js

import { useCallback } from 'react';

/**
 * Custom hook untuk melakukan smooth scroll ke elemen berdasarkan ID.
 * @returns {Function} Sebuah fungsi yang menerima ID elemen sebagai argumen dan melakukan scroll.
 */
const useScrollToId = () => {
  const scrollToElement = useCallback((id) => {
    const targetElement = document.getElementById(id);
    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: "smooth"
      });
    }
  }, []);

  return scrollToElement;
};

export default useScrollToId;